import * as yup from "yup";

export function CostCentersValidate() {
    return yup.object().shape({
        cost_center_code: yup.string().required("Centro de custo não informada."),
        name: yup.string().required("Nome não informado."),
    });
}

export function ControllingAreaValidate() {
    return yup.object().shape({
        name: yup.string().required("Nome é obrigatório").min(3, "Nome deve ter mais que três caracteres"),
        cost_centers: yup.array().required("Centros de Custo não informados").min(1, "Nenhum centro de custo informado").of(CostCentersValidate()),
    });
}
